import { useMemo } from 'react';

import {
   AlignItems,
   createDynamicColumnsWidth,
   InteractiveTable,
   InteractiveTableColumnConfiguration,
   JustifyContent,
} from '@dreryk/react-components';

import { EmergencyNotificationSmsConfigurationContactPersonValue } from '../EmergencyNotificationSmsConfigurationContactPersonsField.types';
import { translationKeys } from '../../../../translations';

import { EmergencyNotificationSmsConfigurationContactPersonNameCell } from './cells/EmergencyNotificationSmsConfigurationContactPersonNameCell';
import { EmergencyNotificationSmsConfigurationContactPersonPhoneNumberCell } from './cells/EmergencyNotificationSmsConfigurationContactPersonPhoneNumberCell';

export const useEmergencyNotificationSmsConfigurationContactPersonsInteractiveTableColumnConfigurationOptions = (): InteractiveTableColumnConfiguration<EmergencyNotificationSmsConfigurationContactPersonValue>[] => {
   return useMemo((): InteractiveTableColumnConfiguration<EmergencyNotificationSmsConfigurationContactPersonValue>[] => {
      const columnWidths = createDynamicColumnsWidth({
         name: '60%',
         phoneNumber: '40%',
         options: '24px',
      });

      return [
         {
            name: 'name',
            label: translationKeys.contactName,
            width: columnWidths.name,
            justifyContent: JustifyContent.START,
            alignItems: AlignItems.CENTER,
            renderer: ({ bean, index }) => {
               return (
                  <EmergencyNotificationSmsConfigurationContactPersonNameCell
                     testId={'name'}
                     name={'name'}
                     index={index}
                     defaultValue={bean.name}
                  />
               );
            },
         },
         {
            name: 'phoneNumber',
            width: columnWidths.phoneNumber,
            justifyContent: JustifyContent.START,
            alignItems: AlignItems.CENTER,
            label: translationKeys.phoneNumber,
            renderer: ({ bean, index }) => {
               return (
                  <EmergencyNotificationSmsConfigurationContactPersonPhoneNumberCell
                     testId={'phoneNumber'}
                     name={'phoneNumber'}
                     index={index}
                     defaultValue={bean.phoneNumber}
                  />
               );
            },
         },

         {
            name: 'options',
            width: columnWidths.options,
            renderer: ({ index, rowsCount }) => {
               return <InteractiveTable.DeleteRowCell index={index} disabled={rowsCount <= 1} />;
            },
         },
      ];
   }, []);
};
